import { ATTENDEE_PAGE_KEYWORD } from 'bookwithme-shared/lib/store/schema/BookWithMeRouteConstants';

const attendeePathRegex = new RegExp(`\\/${ATTENDEE_PAGE_KEYWORD}`, 'i');

export function isAttendeePath(): boolean {
    return attendeePathRegex.test(window.location.pathname);
}
